import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import CollaborationPart1 from './CollaborationPart1';
import CollaborationPart2 from './CollaborationPart2';
import CollaborationPart3 from './CollaborationPart3';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};

const CollaborationsLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#SafetyLab') {
      setBackI(appColors['ColorA']);
      setBackII('transparent');
      setBackIII('transparent');
    } else if (key === '#SafetyProto') {
      setBackI('transparent');
      setBackII(appColors['ColorA']);
      setBackIII('transparent');
    } else if (key === '#Ethics') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorA']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#SafetyLab' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>iGEM Brazil</Text></Content>}/>
          <Link href='#SafetyProto' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>AFCM Egypt</Text></Content>}/>
          <Link href='#Ethics' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>IGEM UAM</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorA'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> C&nbsp;<br/> O&nbsp;<br/> L&nbsp;<br/> L&nbsp;<br/> A&nbsp;<br/> B&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='SafetyLab'>
              <CollaborationPart1/>
            </div>
            <div id='SafetyProto'>
              <CollaborationPart2/>
            </div>
            <div id='Ethics'>
              <CollaborationPart3/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default CollaborationsLogic;
